import React, { useState, useEffect } from 'react'; 
import Nabvar from '../Components/Navbar/Navbar' 
import { Outlet } from 'react-router-dom'; 
import { useMediaQuery } from '@react-hook/media-query'; 
import Footer from '../Components/Footer/Footer' 
import BtnWhatsapp from '../Components/BtnWhatsapp/BtnWhatsapp' 
import Cart from '../Components/Cart/Cart' 

export default function PagesLayaut() {        
    const isScreenLarge = useMediaQuery('(min-width: 900px)');     
    
    return (         
        <div>
            {/* Navbar condicional PERO Outlet siempre en el mismo lugar */}
            {isScreenLarge && <Nabvar />}
            
            {/* Outlet SIEMPRE en la misma posición */}
            <Outlet />
            
            {/* Footer y otros componentes */}
            <Footer />
            {isScreenLarge && <BtnWhatsapp />}
            <Cart />
            
            <div className='espaciobg2'></div>
        </div>     
    ); 
}